var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 558,
    height: 470,
    viewBox: "0 0 558 470",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0C3.00271 28.2952 4.0036 43.9586 13.0117 79.3276C38 140 57.5516 158.655 57.5516 158.655C85.5285 185.687 99.0888 196.261 128.115 209.182C173.229 229.266 192.215 238.782 200.179 248.593C215.193 267.089 212.524 283.439 215.193 310.236C219.697 368.848 248.055 392.508 297.266 421.901C342.281 444.823 385 459.5 419.5 464C423.536 464.526 448.815 466.966 475 466.87L558 469.5V0H0Z",
    fill: "url(#paint0_linear_15_8)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_15_8",
    x1: 219.196,
    y1: 321.352,
    x2: 561.591,
    y2: -1.26774,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBC4BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BB5555",
    stopOpacity: 0.866667
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBg);
export default __webpack_public_path__ + "static/media/bg.18ebd3592263dd41869a4819a8e9d8f3.svg";
export { ForwardRef as ReactComponent };